
import styled from "styled-components";

export const StyledDuplicatePopup = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);

  display: flex;
  justify-content: center;
  align-items: center;

  .post-info {
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: center;
    background: white;
    padding: 25px 35px;
    border-radius: 3px;
    width: 400px;

    .post-title {
      font-size: 22px;
      font-weight: bold;
    }
  }

  .post-info-body {
   width: 100%;
    .language {
      width: 100%;
      padding-bottom: 20px;

      .language-input {
        margin-top: 5px;
      }
    }
  }

  .post-info-footer {
    display: flex;
    justify-content: space-evenly;
    width: 100%;
    padding-top: 20px;
  }
`;